import { Injectable } from '@angular/core';
import { HttpServiceBuilder, HttpServiceConfig } from '../util/http.service';
import { User, userCreateEncoder, userDecoder, UserType, userUpdateEncoder } from '../models/user';
import { EntityService } from '../util/entity.service';

@Injectable({
  providedIn: 'root'
})
export class UsersService extends EntityService<User, {}> {
  constructor(httpServiceBuilder: HttpServiceBuilder<User>) {
    super(httpServiceBuilder, 'users', userDecoder);
  }

  getCreateConfig(user: User): HttpServiceConfig<User> {
    return {
      ...super.getCreateConfig(user),
      encoder: userCreateEncoder,
      route: this.getRouteFromType(user.type)
    };
  }

  getUpdateConfig(user: User): HttpServiceConfig<User> {
    return {
      ...super.getUpdateConfig(user),
      encoder: userUpdateEncoder,
    };
  }

  private getRouteFromType(userType: UserType): string {
    switch (userType) {
      case UserType.Owner:
        return 'user/owner';
      case UserType.Technical:
        return 'user/technical';
      case UserType.LocationManager:
        return 'user/location_manager';
      case UserType.Manager:
        return 'user/manager';
      case UserType.FieldTechnician:
        return 'user/field_technician';
      case UserType.WarehouseClerk:
        return 'user/warehouse_clerk';
      case UserType.Member:
      default:
        return 'user/member';
    }
  }
}
